<template>
  <a-locale-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-locale-provider>
</template>

<script>
import './assets/assets/common.less'
import { close } from './utils/socket.js'
// import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { AppDeviceEnquire } from '@/utils/mixin'
// 引用cdn还可以这么写
import { locales } from 'ant-design-vue'
const zhCN = locales.zh_CN

export default {
  mixins: [AppDeviceEnquire],
  data() {
    return {
      locale: zhCN
    }
  },
  beforeDestroy() {
    close()
  }
}
</script>
<style>
.has-error .ant-form-explain,
.has-error .ant-form-split {
  line-height: 1.3;
}

.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice {
  color: rgba(0, 0, 0, 0.85) !important;
}

.ant-select-disabled {
  color: rgba(0, 0, 0, 0.85) !important;
}

.ant-input-disabled {
  background-color: #f5f5f5;
  opacity: 1;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.85) !important;
}

#app {
  height: 100%;
}

.ant-divider.ant-divider-horizontal {
  margin: 12px 0 !important;
}

.standardTable {
  :global {
    /deep/ .ant-table th {
      white-space: nowrap !important;
    }

    /deep/ .ant-table-tbody>tr>td {
      white-space: nowrap !important;
      padding: 6px 16px !important;
    }
  }
}
</style>
